export const USER_TYPES = {
  SUPER_ADMIN: 'Super Admin User',
  NATIONAL_LEVEL_USER: 'National Level User',
  STATE_LEVEL_USER: 'State Level User',
  DISTRICT_LEVEL_USER: 'District Level User',
  BLOCK_LEVEL_USER: 'Block Level User',
  ULB_LEVEL_USER:'ULB Level User',
  HEALTH_BLOCK_SUB_DIVISION_USER: 'Health Block/ Sub Division Level User',
  ZONE_CIRCLE_LEVEL_USER:'Zone / Circle / Region / Division Level User',
  FACILITY_LEVEL_USER: 'Facility Level User',
  FIELD_LEVEL_USER: 'Field Level User',
  ANM: 'ANM',
};